import { Exclude, Type } from 'class-transformer';
import { DimensionOptionSelectorResultDto } from './dimension-option-selector-result-dto';

export class DimensionSelectorResultDto {
    code: string;
    text: string;
    required: boolean;

    @Type(() => DimensionOptionSelectorResultDto)
    options: Array<DimensionOptionSelectorResultDto>;

    // Transient
    @Exclude()
    selectedOptionCodes: Array<string>;

    @Exclude()
    isEditable: boolean;

    @Exclude()
    selectedDimensionOptionCode: string;
}
